/* eslint-disable react/prop-types */
import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import Dropzone, { useDropzone } from "react-dropzone";
import {
  Form,
  Modal,
  Row,
  Col,
  Button,
  Alert,
  Spinner,
  ListGroup,
} from "react-bootstrap";
import { Formik } from "formik";
import * as yup from "yup";
import API from "../../Utility/Api";

export default function ImportWorkflowUsersFormModal({ workflow, show, onCancel, onSuccess }) {
  const [isLoading, setIsLoading] = useState(false);

  const onDrop = useCallback((acceptedFiles, setFieldError, setFieldValue) => {
    if (!acceptedFiles || acceptedFiles.length !== 1) {
      alert("Please drop 1 file only");
    } else {
      setFieldValue("file", acceptedFiles[0], false);
      setFieldError("file");
      // setFile(acceptedFiles[0]);
    }
    setSubmitError(null);
  }, []);
  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  // API Config
  const { project } = useParams(); // project needed for API
  let formData = new FormData();
  const apiCallConfig = {
    url: `/admin/${project}/workflows/${workflow._id}/uploadWorkflowUsersXlsx`,
  };

  const [submitError, setSubmitError] = useState();
  const [result, setResult] = useState();
  // const [formValidated, setFormValidated] = useState(false);

  function validate(values) {
    const errors = {};
    if (values.file === null || values.file === undefined) {
      errors.file = "Required";
    }
    return errors;
  }
  const submitForm = (values, { setSubmitting }) => {
    const callApi = async function () {
      try {
        setSubmitting(true);
        formData.append("file", values.file);
        apiCallConfig.data = formData;
        const res = await API.postFile(apiCallConfig);
        setSubmitting(false);
        setResult(res);
        setSubmitError();
      } catch (err) {
        let errorResponse = {
          total: 0,
          created: 0,
          errored: 0,
          errors: [],
        };
        if (err?.response?.data?.errors) {
          errorResponse.errors = err.response.data.errors;
          errorResponse.errored = err.response.data.errors.length;
          errorResponse.total = err.response.data.errors.length;
        }
        if (err?.response?.data?.workflowUsers) {
          errorResponse.created = err.response.data.workflowUsers.length;
          errorResponse.total += err.response.data.workflowUsers.length;
        }
        setResult(errorResponse);
        setSubmitting(false);
        if (!err.response && err.message) {
          setSubmitError(err.message);
        } else {
          setSubmitError(
            err &&
              err.response &&
              err.response.data &&
              err.response.data.message
          );
        }
      }
    };
    callApi();
  };

  const resultErrors = [];
  if (result && result.errors && result.errors.length > 0) {
    const maxFive = Math.min(5, result.errors.length);
    for (let index = 0; index < maxFive; index++) {
      if (result.errors[index].error) {
        resultErrors.push(
          <li key={index}>
            {result.errors[index].error} (Spreadsheet row {result.errors[index].index + 1})
          </li>
        );
      } else {
        resultErrors.push(
          <li key={index}>
            {result.errors[index]}
          </li>
        );
      }
    }
  }

  const downloadXlsxExampleFile = async () => {
    const element = document.createElement("a");
    element.href = "https://cdn.pubhubstudio.com/examples/Import%20Workflow%20Users%20Example.xlsx";
    element.download = "import-users-example-" + Date.now() + ".xlsx";
    // simulate link click
    document.body.appendChild(element);
    // Required for this to work in FireFox
    element.click();
  };

  const downloadXlsxTemplateFile = async () => {
    const element = document.createElement("a");
    element.href = "https://cdn.pubhubstudio.com/examples/Import%20Workflow%20Users%20Template.xlsx";
    element.download = "import-users-template-" + Date.now() + ".xlsx";
    // simulate link click
    document.body.appendChild(element);
    // Required for this to work in FireFox
    element.click();
  };

  const theResult = (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      scrollable
      show={show}
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          Import Workflow Users Result
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group as={Row}>
            <Col xs={6} md={4} lg={3}>
              Uploaded:
            </Col>
            <Col xs={6} md={8} lg={9}>
              {result?.total ? result.total : "0"}
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Col xs={6} md={4} lg={3}>
              Created:
            </Col>
            <Col xs={6} md={8} lg={9}>
              {result?.created ? result.created : "0"}
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Col xs={6} md={4} lg={3}>
              Error Count:
            </Col>
            <Col xs={6} md={8} lg={9}>
              {result?.errored ? result.errored : "0"}
            </Col>
          </Form.Group>
          {result && result.errors && result.errors.length > 0 ? (
            <>
              <Form.Group as={Row}>
                <Col xs={6} md={4} lg={3}>
                  Errors (max. 5):
                </Col>
                <Col xs={6} md={8} lg={9}>
                  <ul className="upload_users_modal--errors_list">
                    {resultErrors}
                  </ul>
                </Col>
              </Form.Group>
            </>
          ) : (
            <></>
          )}
          {result?.created > 0 ? (
            <Alert variant="success">{result.created} user{result.created === 1 ? '' : 's'} imported successfully</Alert>
          ) : (
            <></>
          )}
          {submitError && (
            <Alert variant="danger">Error: {submitError?.indexOf('MIME type') !== -1 ? 'Incorrect file type. Only .xlsx files accepted' : submitError}</Alert>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={(e) => {
            onSuccess(e);
            setSubmitError();
            setResult();
          }}
          variant="outline-secondary"
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );

  const theForm = (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      scrollable
      show={show}
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          Import Users
        </Modal.Title>
      </Modal.Header>

      <Formik validate={validate} onSubmit={submitForm} initialValues={{}}>
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          isValid,
          errors,
          submitCount,
          setFieldValue,
          setFieldError,
          isSubmitting,
        }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Modal.Body>
              <Form.Group as={Row} controlId="selectCsvFileFormGroup">
                <Col>
                  <Form.Label>
                    Upload File
                    (
                    <a
                      className='downloadLink'
                      onClick={downloadXlsxExampleFile}
                    >
                      download example
                    </a>
                    )
                    (
                    <a
                      className='downloadLink'
                      onClick={downloadXlsxTemplateFile}
                    >
                      download template
                    </a>
                    )
                  </Form.Label>
                  <Dropzone
                    onDrop={(e) => {
                      onDrop(e, setFieldError, setFieldValue);
                    }}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <div
                        {...getRootProps()}
                        className="upload_users_modal--dropzone"
                      >
                        <input {...getInputProps()} />
                        <span>
                          {values.file
                            ? `${values.file.name}`
                            : "Click to select or drag-and-drop here"}
                        </span>
                        {submitCount > 0 && errors.file ? (
                          <Form.Control.Feedback
                            type="invalid"
                            style={errors.file ? { display: "block" } : {}}
                          >
                            {errors.file}
                          </Form.Control.Feedback>
                        ) : null}
                      </div>
                    )}
                  </Dropzone>
                </Col>
              </Form.Group>
              {submitError && (
                <Alert variant="danger">Error: {submitError?.indexOf('MIME type') !== -1 ? 'Incorrect file type. Only .xlsx files accepted' : submitError}</Alert>
              )}
            </Modal.Body>
            <Modal.Footer>
              {!isSubmitting ? (
                <div style={{ width: "100%", textAlign: "right" }}>
                  <Button style={{ marginRight: "10px" }} onClick={() => {
                    setSubmitError();
                    onCancel();
                  }} variant="outline-secondary">
                    Cancel
                  </Button>
                  <Button variant="outline-primary" type="submit">
                    Save
                  </Button>
                </div>
              ) : (
                <Spinner animation="border" role="status">
                  <span className="sr-only">Loading...</span>
                </Spinner>
              )}
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
  return result ? theResult : theForm;
}
